<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    title="Change Password"
    submit-name="Change Password"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <lm-change-password ref="inputChangePassword" @submit="submitFromInput" />
    <p class="mt-4 text-gray-700">
      After you submit your new password, we will send you an email to
      <span class="text-gray-900" v-text="userData.email"></span> to confirm the
      password change.
    </p>
  </form-modal>
</template>
<script>
import {mapGetters} from 'vuex'
import {Events, Modal} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmChangePassword from '@/components/form/LmChangePassword.vue'
import FormHelper from '@/components/form/formHelper'

export default {
  name: 'ModalChangePassword',
  components: {
    FormModal,
    LmChangePassword
  },
  data() {
    return {
      Events,
      modalName: Modal.CHANGE_PASSWORD,
      modalRef: null,
      inputs: null
    }
  },
  computed: mapGetters(['userData']),
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [this.$refs.inputChangePassword]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        // Call API
        let payload = {
          password: this.$refs.inputChangePassword.data
        }
        this.$store
          .dispatch('editProfile', payload)
          .then(() => this.modalRef.submitSuccess())
          .catch(error => this.modalRef.submitFails(error))
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(
          Events.SHOW_SNACKBAR,
          'A confirmation mail has been sent to your email account'
        )
      }
    }
  }
}
</script>
